(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  if (!mobile.matches) return;

  const nav = document.querySelector('[data-vjn]');
  if (!nav) return;

  const toggle = nav.querySelector('[data-vjn-toggle]');
  const panel = nav.querySelector('[data-vjn-panel]');
  const currentLabel = nav.querySelector('[data-vjn-current]');
  const currentStep = nav.querySelector('[data-vjn-step]');
  const progress = nav.querySelector('[data-vjn-progress]');
  const gsap = window.gsap;
  const ScrollTrigger = window.ScrollTrigger;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let links = [];
  let triggers = [];
  let activeIndex = 0;
  let open = false;

  const setOpen = (nextOpen, returnFocus = false) => {
    if (open === nextOpen || !toggle || !panel) return;
    open = nextOpen;
    toggle.setAttribute('aria-expanded', String(open));

    if (open) {
      panel.hidden = false;
      if (gsap && !reducedMotion) {
        gsap.fromTo(panel, {
          y: 12,
          scale: .975,
          autoAlpha: 0
        }, {
          y: 0,
          scale: 1,
          autoAlpha: 1,
          duration: .42,
          ease: 'power3.out',
          overwrite: 'auto'
        });
      }
      return;
    }

    const hidePanel = () => {
      panel.hidden = true;
      if (returnFocus) toggle.focus({ preventScroll: true });
    };

    if (gsap && !reducedMotion) {
      gsap.to(panel, {
        y: 8,
        scale: .985,
        autoAlpha: 0,
        duration: .24,
        ease: 'power2.in',
        overwrite: 'auto',
        onComplete: hidePanel
      });
    } else {
      hidePanel();
    }
  };

  const setActive = (index) => {
    if (!links.length) return;
    activeIndex = Math.max(0, Math.min(index, links.length - 1));
    links.forEach(({ link }, linkIndex) => {
      if (linkIndex === activeIndex) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });

    const active = links[activeIndex];
    const total = String(links.length).padStart(2, '0');
    const step = String(activeIndex + 1).padStart(2, '0');
    if (currentLabel) currentLabel.textContent = active.label;
    if (currentStep) currentStep.textContent = `${step} / ${total}`;
    if (progress) progress.style.setProperty('--vjn-progress', ((activeIndex + 1) / links.length).toFixed(4));
  };

  const rebuild = () => {
    triggers.forEach((trigger) => trigger.kill());
    triggers = [];
    links = Array.from(nav.querySelectorAll('[data-vjn-link]')).map((link) => {
      const target = document.querySelector(link.getAttribute('href'));
      link.hidden = !target;
      return target ? { link, target, label: link.dataset.label || link.textContent.trim() } : null;
    }).filter(Boolean);

    if (links.length < 2) {
      nav.hidden = true;
      return;
    }

    nav.hidden = false;
    window.requestAnimationFrame(() => nav.classList.add('is-ready'));
    setActive(Math.min(activeIndex, links.length - 1));

    if (ScrollTrigger) {
      links.forEach(({ target }, index) => {
        triggers.push(ScrollTrigger.create({
          id: `vorliva-journey-${index}`,
          trigger: target,
          start: 'top 58%',
          end: 'bottom 42%',
          onEnter: () => setActive(index),
          onEnterBack: () => setActive(index)
        }));
      });
    }
  };

  toggle?.addEventListener('click', () => setOpen(!open));

  nav.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-vjn-link]');
    if (!link) return;
    const item = links.find((candidate) => candidate.link === link);
    if (!item) return;
    event.preventDefault();
    setActive(links.indexOf(item));
    setOpen(false);
    item.target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  });

  document.addEventListener('pointerdown', (event) => {
    if (open && !nav.contains(event.target)) setOpen(false);
  }, { passive: true });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && open) setOpen(false, true);
  });

  document.addEventListener('shopify:section:load', rebuild);
  document.addEventListener('shopify:section:unload', () => window.requestAnimationFrame(rebuild));
  rebuild();
})();
